var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddDrawing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H12",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5V11",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0755 8H15H22.7705C24.4274 8 25.7705 9.34315 25.7705 11V22C25.7705 23.6569 24.4274 25 22.7705 25H11.7705M8.77051 14V14.0947V22C8.77051 22.7684 9.05936 23.4692 9.5344 24",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.822 8.16554C26.7284 8.07174 26.6047 8.01391 26.4726 8.0022C26.3406 7.9905 26.2087 8.02567 26.1 8.10154H26.07C21.7903 11.175 17.7549 14.5752 14 18.2715L16.7 21.0015C20.3912 17.2421 23.786 13.2027 26.854 8.91954H26.885C26.9693 8.8084 27.0095 8.66998 26.9979 8.53096C26.9863 8.39194 26.9236 8.26213 26.822 8.16654V8.16554Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5501 18.7956C13.1979 19.1478 13 19.6255 13 20.1236C13 20.6217 13.1979 21.0994 13.5501 21.4516C13.9023 21.8038 14.38 22.0017 14.8781 22.0017C15.3762 22.0017 15.8539 21.8038 16.2061 21.4516L17.0001 20.6576L14.3741 18.0016L13.5501 18.7956Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.415 24.1765C13.5991 24.0105 13.7462 23.8076 13.847 23.5811C13.9477 23.3546 13.9997 23.1095 13.9997 22.8615C13.9997 22.6136 13.9477 22.3685 13.847 22.142C13.7462 21.9155 13.5991 21.7126 13.415 21.5465C13.0285 21.1955 12.5251 21.001 12.003 21.001C11.4809 21.001 10.9775 21.1955 10.591 21.5465C9.163 22.8455 9.661 25.5375 8 26.0015C9.561 25.9085 11.821 25.6615 13.415 24.1765Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDrawing);
export default __webpack_public_path__ + "static/media/add-drawing.c25bfe03bd17caec07d81f0c5744a499.svg";
export { ForwardRef as ReactComponent };